import React from 'react';

/**
 * This function checks the validity of every purchase orders in purchaseOrderDetails List
 * @param {list} purchaseOrderDetails // list of purchase orders
 * @returns {boolean} true if evenry purchase order is valid else false
 */
export const isPoDetailsVaild = (purchaseOrderDetails, isPoDetailsRequired) => {
  const length = purchaseOrderDetails.length;

  // If PO details are not required and there is only one empty entry, skip validation
  if (
    !isPoDetailsRequired &&
    length === 1 &&
    purchaseOrderDetails[0].po === '' &&
    purchaseOrderDetails[0].units === '' &&
    !purchaseOrderDetails[0].poExpiryTime
  ) {
    return [true, ''];
  }

  for (let i = 0; i < length; i++) {
    if (!purchaseOrderDetails[i].po) {
      return [false, 'Enter PO Number'];
    } else if (!purchaseOrderDetails[i].units) {
      return [false, 'Enter No. of Units'];
    } else if (!purchaseOrderDetails[i].poExpiryTime) {
      return [false, 'Enter PO Expiry Date'];
    } else if (purchaseOrderDetails[i].po.length < 5) {
      return [false, 'PO Number must have atleast 5 digits'];
    } else if (purchaseOrderDetails[i].units === '0') {
      return [false, 'No. of Units cannot be 0'];
    }
  }
  return [true, ''];
};

export const deliveryClientWithPODetails = {
  AMAZON: 'AMAZON',
  FLIPKART: 'FLIPKART',
  BLINKIT: 'BLINKIT'
};

export const defaultPODetail = {
  po: '',
  units: '',
  poExpiryTime: null
};

export const isPoDetailsRequired = deliveryClient =>
  deliveryClient === deliveryClientWithPODetails.AMAZON ||
  deliveryClient === deliveryClientWithPODetails.FLIPKART ||
  deliveryClient === deliveryClientWithPODetails.BLINKIT;
